export default __webpack_public_path__ + "static/media/coursera.f71c5171.png";